import API from '../../API/api'
import { GettingProblemByReferenceCode } from '../Problem/problemHelper';

export const GettingAllUnits = async () => {
    try {
        const res = await API.get('/unit')
        return res.data
    } catch (err) {
      if (err.response?.status === 404) {
      return []; // not found → return empty array
    }
        console.error("Error fetching submission:", err);
        throw err
    }
}

export const GettingUnitById = async (unitId) => {
    try {
        const res = await API.get(`/unit/${unitId}`)
        if (!res) return res.status(404).json({ message: "Unit not found" });
        const unit = res.data
        
        const problems =  (  await Promise.all(
        (unit.problems || []).map(async (p) => {
          const problem = await GettingProblemByReferenceCode(p.referenceCode);

          if (problem.found) {
            return {
              ...problem.Problem, // actual Problem schema data
              hint: p.hints       // keep the unit-specific hint
            };
          }

          // returning null/undefined will be filtered out
          return null;
        })
      )
    ).filter(Boolean); // remove null/undefined entries
        return {
            ...unit,
            problems
        }
    } catch (err) {
        console.error("Error fetching submission:", err);
        throw err
    }
}